import {SvgIcon, useTheme} from '@mui/material';

export default function SearchIcon() {
	const theme = useTheme();
	// @ts-ignore
	const color = theme.palette.mode === 'light' ? theme.palette.primary[800] : theme.palette.primary.main;
	return (
		<SvgIcon>
			<mask id="mask0_441_1957" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
				<rect width="24" height="24" fill="#D9D9D9"/>
			</mask>
			<g mask="url(#mask0_441_1957)">
				<path
					d="M11.5811 20.165C6.8497 20.165 2.99756 16.3128 2.99756 11.5814C2.99756 6.84995 6.8497 2.9978 11.5811 2.9978C16.3126 2.9978 20.1647 6.84995 20.1647 11.5814C20.1647 16.3128 16.3126 20.165 11.5811 20.165ZM11.5811 4.25394C7.53639 4.25394 4.25369 7.54501 4.25369 11.5814C4.25369 15.6178 7.53639 18.9088 11.5811 18.9088C15.6259 18.9088 18.9086 15.6178 18.9086 11.5814C18.9086 7.54501 15.6259 4.25394 11.5811 4.25394ZM20.3741 21.0032C20.215 21.0032 20.0559 20.9446 19.9302 20.819L18.2554 19.1442C18.1386 19.026 18.0731 18.8665 18.0731 18.7003C18.0731 18.5341 18.1386 18.3747 18.2554 18.2565C18.4983 18.0136 18.9002 18.0136 19.1431 18.2565L20.8179 19.9313C21.0608 20.1742 21.0608 20.5761 20.8179 20.819C20.6923 20.9446 20.5332 21.0032 20.3741 21.0032Z"
					fill={color}/>
			</g>
		</SvgIcon>
	);
}
